import {SmartComponent} from "smart-component-js";
import FormUtils from "../common/FormUtils";
import LandingUrlBuilder from "../business/LandingUrlBuilder";
import FormBaseComponent from "./FormBaseComponent";

class FormOpenDayComponent extends FormBaseComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "FormOpenDayComponent";
        super(element, parentComponent, params);

        this.$el = $(element);

        //Real inputs
        this.$degreeLevel = this.$el.find('[name="Degree_Level__c"]');
        this.$course = this.$el.find('[name="Program_Of_Interest__c"]');
        this.$intake = this.$el.find('[name="School_Term__c"]');
        this.$campus = this.$el.find('[name="CampusLocation__c"]');

        this.$urlBackField = this.$el.find('[name="redirectURL"]');

        //Fields
        this.$degreeLevelField = this.$el.find('#course-type');

        //Constants
        this.formType = this.$el.data('formType');

        //Variable values
        this.selectedDegreeLevel = '';
        this.normaAreaToCourses = {};
        this.normalCoursesToCampus = {};

        this.allowSubmit = false;

        this.init();
    }

    init() {
        this.$el.find('[type="submit"]').click((e) => {
            if (!FormUtils.validateForm(this)) {
                e.preventDefault();
            }
            if (!FormUtils.validateFields(this.$el.find('input:visible, select:visible'))) {
                e.preventDefault();
                $("html, body").stop().animate({scrollTop: this.$el.find('.has-error:eq(0)').offset().top - 120}, 500, 'swing');
            } else if (!this.allowSubmit) {
                e.preventDefault();
                this.allowSubmit = true;
                FormUtils.showLoader(this.$el);

                FormUtils.doCaptcha(e, this.$el, this.$urlBackField, this.formType);
            }
        });
        FormUtils.addFormListeners(this.$el);

        this.$el.find('[name="event_location_type"]').change(() => {
            FormUtils.updateIdCampaign(this.$el);
        });

        this.$degreeLevelField.change(() => {
            this.$el.find('.course-info-msection').hide();
            this.$degreeLevel.val('');
            this.$course.val('');
            this.$course.data('courseLabel', null);
            this.$intake.val('');
            this.$campus.val('');

            this.selectedDegreeLevel = this.$degreeLevelField.val();
            let dlKey = this.$degreeLevelField.find('option:selected').attr('value') || '';
            this.$degreeLevel.val(dlKey);

            if (!!dlKey) {
                this.showCourseSelector();
            }
        });

        this.manageNormal();
        this.manageGeneral();
    }
}

export default FormOpenDayComponent;